

const TtkList = ({ data=[] }) => {

    return (
        data && (
            <p className="ms-4">{data?.map((item, index, array) => { return (<span key={index}>{item?.value}{index < array?.length - 1 && ','}</span>) })}</p>
        )
    )
}

export default TtkList